import React from 'react';

const Assess_cli = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6">
      <h3 className="text-2xl font-bold mt-10 ">Who are our Clients?</h3>
      
    </div>
  );
}

export default Assess_cli;
